import React, { Fragment } from 'react'

const StepError = ({ submitStep, stepImage }) => {
	return (
		<Fragment>
			<div className='step__illustration'>
				<img src={stepImage} width='100%' />
			</div>
			<div className='step__question step-red-900 mb-5'>
				<p>
					Opa! Aconteceu um erro inesperado durante o processamento da sua
					resposta, clique no botão abaixo para tentar envia-lá novamente. Caso
					não consiga prosseguir, por favor entre em contato com o suporte.
				</p>
				<button className='button-verm match-maker-button' onClick={submitStep}>
					Tentar novamente
				</button>
			</div>
		</Fragment>
	)
}

export { StepError }
